import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Slide from "@material-ui/core/Slide";
import Alert from "@material-ui/lab/Alert";

import { StoreState, Notification } from "models";

import { useDispatch, useSelector } from "react-redux";
import { closeNotification } from "redux/LogBox/LogBox.actions";

export default function CustomizedSnackbars() {
  const dispatch = useDispatch();
  const snackbar: Notification = useSelector((state: StoreState) => state.logbox.snackbar);

  const handleClose = () => {
    dispatch(closeNotification())
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      autoHideDuration={5000}
      open={snackbar.isOpen}
      onClose={handleClose}
      TransitionComponent={Slide}
    >
      <Alert variant="filled" onClose={handleClose} severity={snackbar.severity}>
        {snackbar.text}
      </Alert>
    </Snackbar>
  );
}
